<ng-template #content_bill_taxes let-offcanvas>
    <div class="{{localService.selectedLanguageCode}} bill-taxes"
        *ngIf="billedItemsFinal && localService.languageContent && localService.languageContent.product_config">
        <div class="side_popup_header">
            <span>{{localService.languageContent.product_config.biz_taxes}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" [ngStyle]="{'max-height' : (localService.sideBarBodyHeight - 90) + 'px'}">
            <div *ngIf="isDetailedTax">
                <div>
                    <div class="banner" style="margin: 25px;" *ngFor="let item of billedItemsFinal.products;">
                        <div class="row">
                            <div class="col-12" style="text-align: center;">
                                <app-label [Text]="item.details.v3"
                                    [LanguageCode]="localService.getLanguageCode(item.details.v6)"
                                    [IsColonRequired]="false" [IsBold]="true" />
                                <span class="en" *ngIf="item.details.v15"
                                    style="font-style: italic;">&nbsp;({{item.details.v16}})</span>
                            </div>
                        </div>
                        <div class="row styled_row">
                            <div class="col-8">
                                <app-label [Text]="localService.languageContent.product_config.price_base"
                                    [IsMandatory]="true" [IsColonRequired]="false" />
                            </div>
                            <div class="col-4" style="text-align: right;">
                                <span
                                    class="en">{{onGetBaseAmountForProduct(item.productId,item.details.v15,item.details.v5).toFixed(2)}}</span>
                            </div>
                        </div>
                        <div *ngIf="item.details.v26 != '1'">
                            <div
                                *ngFor="let tax of onGetRequitredTaxForProduct(item.productId,item.details.v24,item.details.v15,item.details.v5,true);">
                                <div class="row styled_row" *ngIf="tax.value">
                                    <div class="col-8">
                                        <app-label [Text]="onGetTitle(tax.key, 2)" [IsColonRequired]="false" />
                                        <span class="en">&nbsp;({{tax.value ? tax.value : '0'}})&nbsp;</span>
                                    </div>
                                    <div class="col-4" style="text-align: right;color: slategray;">
                                        <span
                                            class="en">{{onGetTaxAmountForProduct(item.productId,item.details.v24,item.details.v15,item.details.v5,
                                            tax.key,true).toFixed(2)}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row styled_row">
                                <div class="col-8">
                                    <app-label [Text]="localService.languageContent.product_config.taxable"
                                        [IsColonRequired]="false" />
                                </div>
                                <div class="col-4" style="text-align: right;">
                                    <span
                                        class="en"><b>{{onGetTaxableAmountForProductId(item.productId,item.details.v15,item.details.v5).toFixed(2)}}</b></span>
                                </div>
                            </div>
                            <div
                                *ngFor="let tax of onGetRequitredTaxForProduct(item.productId,item.details.v24,item.details.v15,item.details.v5,false);">
                                <div class="row styled_row" *ngIf="tax.value">
                                    <div class="col-8">
                                        <app-label [Text]="onGetTitle(tax.key, 2)" [IsColonRequired]="false" />
                                        <span class="en">&nbsp;({{tax.value ? tax.value : '0'}})&nbsp;</span>
                                    </div>
                                    <div class="col-4" style="text-align: right;color: slategray;">
                                        <span
                                            class="en">{{onGetTaxAmountForProduct(item.productId,item.details.v24,item.details.v15,item.details.v5,
                                            tax.key).toFixed(2)}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row styled_row">
                                <div class="col-8">
                                    <app-label [Text]="localService.languageContent.product_config.price"
                                        [IsColonRequired]="false" />
                                </div>
                                <div class="col-4" style="text-align: right;">
                                    <span
                                        class="en"><b>{{onGetTaxAmountIncludeTaxForProductId(item.productId,item.details.v15,item.details.v5).toFixed(2)}}</b></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!isDetailedTax">
                <div class="banner" style="margin: 25px;">
                    <div class="row styled_row" *ngFor="let item of billedItemsFinal.products;">
                        <div class="col-8">
                            <app-label [Text]="item.details.v3"
                                [LanguageCode]="localService.getLanguageCode(item.details.v6)"
                                [IsColonRequired]="false" />
                            <span class="en" *ngIf="item.details.v15"
                                style="font-style: italic;">&nbsp;({{item.details.v16}})</span>
                        </div>
                        <div class="col-4" style="text-align: right;">
                            <span
                                class="en">{{onGetTaxAmountIncludeTaxForProductId(item.productId,item.details.v15,item.details.v5).toFixed(2)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="side_popup_footer">
            <div class="row">
                <div class="col-8" style="text-align: left;">
                    <span class="normal_color">{{localService.languageContent.billing.service_charge_amount}}</span>
                </div>
                <div class="col-4" style="text-align: right;">
                    {{serviceChargeAmount.toFixed(2)}}
                </div>
            </div>
            <div class="row">
                <div class="col-8" style="text-align: left;">
                    <span class="normal_color">{{localService.languageContent.billing.adjustment}}</span>
                </div>
                <div class="col-4" style="text-align: right;">
                    {{adjustmentAmount.toFixed(2)}}
                </div>
            </div>
            <div class="row">
                <div class="col-8" style="text-align: left;">
                    <span class="normal_color">{{localService.languageContent.billing.discount_amount}}</span>
                </div>
                <div class="col-4" style="text-align: right;">
                    -&nbsp;{{discountAmount.toFixed(2)}}
                </div>
            </div>
            <div class="row">
                <div class="col-8" style="text-align: left;">
                    <label style="font-weight: normal; margin-left: 15px;">
                        <input type="checkbox" [(ngModel)]="isDetailedTax" />
                        <span class="normal_color">{{localService.languageContent.billing.is_detail_tax}}</span>
                    </label>
                </div>
                <div class="col-4" style="text-align: right;color: rgb(0, 140, 186);font-weight: bold;">
                    {{onGetPriceIncludeTax().toFixed(2)}}
                </div>
            </div>
        </div>
    </div>
</ng-template>